import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import Constants from "./../../Utils/Constants";
import LoadingProgress from "./../../Common/LoadingProgress";
import { getToken, getHeaders } from "./../../Utils/Common";
import store from "./../../Common//storage";
import Header from "./../../assets/components/header";

import Pagination from '@material-ui/lab/Pagination';

import "./../../index.css";

const columns = [
  { id: "sms", label: "Sent Message", minWidth: 100 },
  { id: "sender_id", label: "Sender Id", minWidth: 100 },
  {
    id: "name",
    label: `${store?.get('user')?.partner?.whitelabel_name} Contact`,
    minWidth: 100,
    align: "left",
  },
  {
    id: "created_at",
    label: "Send Time",
    minWidth: 190,
    align: "center",
  },
  {
    id: "link_clicks",
    label: `Link Clicks`,
    minWidth: 30,
    align: "left",
  },
];

const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 14,
    fontWeight: 500,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData, setServerData] = React.useState(store.get("history"));
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [open, setOpen] = React.useState(0);
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [dialogData, setDialogData] = React.useState('');
  const [total, setTotal] = React.useState('');
  const [failed, setFailed] = React.useState('');
  const [linkclicks, setLinkclicks] = React.useState('');
  const [unsubclick, setUnsubclick] = React.useState('');
  let interval = null;

  const data = {
    labels: ["DELIVERED", "UNDELIVERABLE"],
    datasets: [
      {
        label: "Delivery Report",
        data: [total, failed],
        backgroundColor: [
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 99, 132, 0.6)",
          // "rgba(255, 206, 86, 0.6)",
          // "rgba(75, 192, 192, 0.6)",
          // "rgba(153, 102, 255, 0.6)",
        ],
        borderColor: [
          "rgba(54, 162, 235, 1)",
          "rgba(255, 99, 132, 1)",
          // "rgba(255, 206, 86, 1)",
          // "rgba(75, 192, 192, 1)",
          // "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    refreshData();
    interval = setInterval(() => {
      refreshData();
    }, 6000);
    return () => {
      clearInterval(interval);
    };
  }, [page]);

  const refreshData = () => {
    axios.get(Constants.getApiPathWithConfigId(Constants.historyApiPath) + `?per_page=20&page=${page}&order_by=id&order=desc`, getHeaders())
                      .then(response => {
                        // setServerData([])
                        setPageCount(response.data.meta.last_page)
                        setTotal(response.data.meta.total)
                        setFailed(response.data.meta.failed_count)
                        setLinkclicks(response.data.meta.link_clicked)
                        setUnsubclick(response.data.meta.unsubscribe_clicked)
                        setServerData(response.data.data)
                      }).catch(error => console.error(error))
  };

  const close = () => {
    setDialogTitle('')
    setDialogData('')
    setOpen(0)
  }

  if (!serverData) {
    return <LoadingProgress />;
  }

  return (
    <div className="panal-viewport middle-container"> 
      <Header name={"SMS Automation History"} />
      <div className="d-flex flex-row">
        <Paper className={` p-2 `} style={{width: '30%'}}>
                  <div className="d-flex">
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Total: { total }</p>
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Delivered: { total - failed }</p>
                  </div>
                  <div className="d-flex">
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Undeliverable: { failed }</p>
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Percentage: {
                      (((total - failed)/total) * 100)
                    }%</p>
                  </div>
                  <div className="d-flex">
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Link Click: { linkclicks }</p>
                    <p style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px', margin: 0, width: '50%'}}>Unsubscribe Click: { unsubclick } </p>
                  </div>
                  <div style={{width: '75%', margin: '30px auto'}}>
                    <Pie data={data} options={options} />
                  </div>
              </Paper>
        <Paper className={`${classes.root} pb-2 flex-grow-1`}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow id="table-head_rw">
                  <StyledTableCell className="table-hd">
                    Sent Message
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Sender ID
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    {/* {store?.get('user')?.partner?.whitelabel_name}  */}
                    Contact
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Send Date,Time
                  </StyledTableCell>
                  <StyledTableCell className="table-hd">
                    Link Clicks
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serverData?.map((row) => {
                  const rowId = row.id;
                  // console.log(row, 'row')
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={rowId}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        if (column.id === "sms") {
                          return (
                            <StyledTableCell
                              component="td"
                              scope="row"
                              key={column.id}
                              style={{maxWidth: '500px'}}
                            >
                              <div className="">
                                <span>{value}</span>
                              </div>
                            </StyledTableCell>
                          );
                        } else if (column.id === "name") {
                          return (
                            <StyledTableCell className="text-blue">
                              {/* <div className="template-info">
                                <div className="template-info__item">
                                  <PermIdentityIcon
                                    fontSize="small"
                                    style={{ fontSize: "0.9rem" }}
                                  />
                                  <span
                                    style={{
                                      fontWeight: "700",
                                      marginLeft: "5px",
                                      color: "#000",
                                    }}
                                  >
                                    {" "}
                                    {value}{" "}
                                  </span>
                                </div>
                              </div> */}
                              <a href={Constants.getAcContactUrl(row.ac_id)} target="_blank" className="text-blue">
                                {row.phone_number}
                              </a>
                            </StyledTableCell>
                          );
                        } else if (column.id === "created_at") {
                          return (
                            <StyledTableCell>
                              <div className="send-time">
                                <span>
                                  {new Date(value).toLocaleString()}
                                </span>
                              </div>
                            </StyledTableCell>
                          );
                        } else if (column.id=="link_clicks") {
                          return (
                            <StyledTableCell className="text-blue">
                              <a href="#" className="text-success" onClick={() => {
                            setDialogTitle('Link Clicks')
                            setDialogData(row?.link_click_data)
                            setOpen(1)
                          }} 
                          title="Link clicks"
                          >
                              {JSON.parse(row?.link_click_data)?.length || 0}
                          </a> | <a href="#" className="text-danger" onClick={() => {
                            setDialogTitle('Unsubscribe Clicks')
                            setDialogData(row?.unsub_link_click_data)
                            setOpen(1)
                          }}
                          title="Unsubscribe link clicks"
                          >
                              {JSON.parse(row?.unsub_link_click_data)?.length || 0}
                          </a> 
                            </StyledTableCell>
                          );
                        } 
                        else {
                          return (
                            <StyledTableCell >
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value}
                            </StyledTableCell>
                          );
                        }
                      })}
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                    <Pagination 
                      count={pageCount} 
                      page={page} 
                      onChange={handleChange} 
                      variant="outlined" 
                      shape="rounded"
                      />
                  </div>}
        </Paper>
        <Dialog
                  onClose={close}
                  aria-labelledby="simple-dialog-title"
                  open={open}
                >
                  <DialogTitle id="simple-dialog-title">
                    {dialogTitle}
                  </DialogTitle>
                  <DialogContent>
                    <div className="form-groups">
                      {
                        dialogData ? <>
                          <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="customized table">
                              <TableHead>
                                <TableRow id="table-head_rw">
                                  <StyledTableCell className="table-hd">
                                    Link
                                  </StyledTableCell>
                                  <StyledTableCell className="table-hd">
                                    Date
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {dialogData && JSON.parse(dialogData)?.map((r, i) => <TableRow key={i}>
                                    <StyledTableCell className="">
                                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                                        <span>
                                          <a href={r?.eventDetails?.link} target="_blank" title={r?.eventDetails?.link}>
                                            {r?.eventDetails?.link.substr(0, 40)}...
                                          </a>
                                        </span>
                                      </div>
                                    </StyledTableCell>
                                    <StyledTableCell className="">
                                      <div className="speech-bubble" style={{maxWidth: '400px', fontWeight: 'normal', fontSize: '14px'}}>
                                        <span>{new Date((r?.timestamp * 1000)).toLocaleDateString()}</span>
                                      </div>
                                    </StyledTableCell>
                                  </TableRow>
                                ) 
                                }
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </> : <span>No data found.</span>
                      }
                    </div>
                  </DialogContent>
                  <DialogActions style={{ padding: "8px 24px 24px" }}>
                    <span
                      className="c-button text-uppercase"
                      style={{ marginRight: "10px" }}
                      onClick={close}
                    >
                      Close
                    </span>
                  </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}
